import React from 'react';
import { TrainingPlansSection } from '../components/TrainingPlansSection';
import { HeroSection } from '../components/HeroSection';
import { FAQSection } from '../components/FAQSection';
import { FreeTipsSection } from '../components/FreeTipsSection';
import { ContactSection } from '../components/ContactSection';
export const TrainingPlansLandingPage: React.FC = () => {
  return <div className="bg-black text-white min-h-screen" data-id="element-2264">
      {/* Hero section - same as main page */}
      <HeroSection data-id="element-2265" />

      {/* Training Plans Section - without progress section */}
      <TrainingPlansSection showProgressSection={false} data-id="element-2266" />

      {/* FAQ Section */}
      <FAQSection data-id="element-2267" />

      {/* Free Tips Section - moved above Contact */}
      <FreeTipsSection data-id="element-2268" />

      {/* Contact Section */}
      <ContactSection data-id="element-2269" />
    </div>;
};